<template>
  <div id="contenedor-contratos-opciones-tool-bar">
    <v-tabs>
      <template
        v-for="(opcion, index) in opciones">
        <v-tab
          :key="index"
          :to="{ name: opcion.ruta }"
          exact>
          {{ opcion.nombre }}
        </v-tab>
      </template>
    </v-tabs>
  </div>
</template>

<script>
export default {
  name: 'ContratosOpcinesToolBar',
  data() {
    return {
      opciones: [
        /*
        {
          nombre: 'Firmas',
          ruta: 'contratosConfiguracionFirmas',
          icono: '',
        }, */
        {
          nombre: 'Plantillas',
          ruta: 'contratosConfiguracionPlantillas',
          icono: '',
        },
        {
          nombre: 'Etiquetas',
          ruta: 'contratosConfiguracionEtiquetas',
          icono: '',
        },
      ],
    };
  },
};
</script>

<style lang="scss">

</style>
